import _regeneratorRuntime from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

// Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.
var Web3Utils = require('web3-utils');

var EthCrypto = require('eth-crypto');

var ConsentContract = require('../contracts/Consent.json');

var Consent =
/*#__PURE__*/
function () {
  function Consent(FDSAccount, contractAddress, swarmHash) {
    _classCallCheck(this, Consent);

    this.account = FDSAccount;
    this.contractAddress = contractAddress;
    this.swarmHash = swarmHash;
    this.con = FDSAccount.Tx.getContract(this.account, ConsentContract.abi, contractAddress);
  }

  _createClass(Consent, [{
    key: "sign",
    value: function sign() {
      var h = this.swarmHash;
      var sigg = EthCrypto.sign(this.account.privateKey, h);
      var sig = sigg.slice(2);
      var sl = sig.slice(128, 130);
      var v = Web3Utils.toDecimal("0x" + sl);
      var r = "0x".concat(sig.slice(0, 64));
      var s = "0x".concat(sig.slice(64, 128));
      return {
        h: h,
        v: v,
        r: r,
        s: s
      };
    }
  }, {
    key: "getSwarmHash",
    value: function () {
      var _getSwarmHash = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.con.call('swarmHash', []);

              case 2:
                this.swarmHash = _context.sent;
                return _context.abrupt("return", this.swarmHash);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSwarmHash() {
        return _getSwarmHash.apply(this, arguments);
      }

      return getSwarmHash;
    }()
  }, {
    key: "dataUser",
    value: function () {
      var _dataUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.con.call('dataUser', []);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function dataUser() {
        return _dataUser.apply(this, arguments);
      }

      return dataUser;
    }()
  }, {
    key: "signUser",
    value: function () {
      var _signUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var sig;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                sig = this.sign();
                _context3.next = 3;
                return this.con.send('signUser', [sig.h, sig.v, sig.r, sig.s]);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function signUser() {
        return _signUser.apply(this, arguments);
      }

      return signUser;
    }()
  }, {
    key: "dataSubject",
    value: function () {
      var _dataSubject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.con.call('dataSubject', []);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function dataSubject() {
        return _dataSubject.apply(this, arguments);
      }

      return dataSubject;
    }()
  }, {
    key: "signSubject",
    value: function () {
      var _signSubject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var sig;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sig = this.sign();
                _context5.next = 3;
                return this.con.send('signSubject', [sig.h, sig.v, sig.r, sig.s]);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function signSubject() {
        return _signSubject.apply(this, arguments);
      }

      return signSubject;
    }()
  }, {
    key: "isUserSigned",
    value: function () {
      var _isUserSigned = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.con.call('isUserSigned', []);

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function isUserSigned() {
        return _isUserSigned.apply(this, arguments);
      }

      return isUserSigned;
    }()
  }, {
    key: "isSubjectSigned",
    value: function () {
      var _isSubjectSigned = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.con.call('isSubjectSigned', []);

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function isSubjectSigned() {
        return _isSubjectSigned.apply(this, arguments);
      }

      return isSubjectSigned;
    }()
  }, {
    key: "isSigned",
    value: function () {
      var _isSigned = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.con.call('isSigned', []);

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function isSigned() {
        return _isSigned.apply(this, arguments);
      }

      return isSigned;
    }()
  }, {
    key: "isValid",
    value: function () {
      var _isValid = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.con.call('isValid', []);

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function isValid() {
        return _isValid.apply(this, arguments);
      }

      return isValid;
    }()
  }, {
    key: "revokeConsent",
    value: function () {
      var _revokeConsent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.con.send('revokeConsent', []);

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function revokeConsent() {
        return _revokeConsent.apply(this, arguments);
      }

      return revokeConsent;
    }()
  }, {
    key: "isUpdatedWith",
    value: function () {
      var _isUpdatedWith = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.con.call('updatedConsent', []);

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function isUpdatedWith() {
        return _isUpdatedWith.apply(this, arguments);
      }

      return isUpdatedWith;
    }()
  }, {
    key: "status",
    value: function () {
      var _status = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.con.call('status', []);

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function status() {
        return _status.apply(this, arguments);
      }

      return status;
    }()
  }]);

  return Consent;
}();

export default Consent;